import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LANGS = [
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'pt', label: 'Português' },
  { code: 'it', label: 'Italiano' },
  { code: 'de', label: 'Deutsch' },
];

export const LanguageSelector = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = (i18n.language || 'es').split('-')[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
    // Persist server-side if logged in (ignore errors on public pages)
    axios.post(`${API}/auth/language`, { language: code }, { withCredentials: true }).catch(() => {});
  };

  return (
    <div className="relative" ref={ref} data-testid="language-selector">
      <button onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-md text-zinc-400 hover:text-white hover:bg-white/5 transition-colors text-xs uppercase font-mono"
        data-testid="language-selector-btn">
        <Globe className="w-4 h-4" />
        <span>{current.toUpperCase()}</span>
      </button>
      {open && (
        <div className={`absolute ${compact ? 'bottom-full mb-1' : 'top-full mt-1'} right-0 z-[60] bg-surface border border-white/10 rounded-md shadow-xl py-1 min-w-[140px]`}
          data-testid="language-dropdown">
          {LANGS.map(l => (
            <button key={l.code} onClick={() => change(l.code)}
              className={`flex items-center justify-between w-full px-3 py-2 text-sm transition-colors ${current === l.code ? 'text-primary' : 'text-zinc-400 hover:text-white hover:bg-white/5'}`}
              data-testid={`language-option-${l.code}`}>
              <span>{l.label}</span>
              {current === l.code && <Check className="w-3 h-3" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
